import type { ProfileRow } from '../../types/supabase'
import { requiresFamilyPlan } from '../../lib/rules/requiredPlan'
import type { IncidentModel } from '../incidentsSlice'
import type { RootState } from '../store'

/**
 * The membership creator's profile, or null when it isn't known (e.g. stale
 * persisted state before the profiles sync completes). Callers must treat null
 * as "cannot determine" — the requiredPlan rules fail open on it.
 */
export function selectCreatorProfile(s: RootState): ProfileRow | null {
  const creatorId = s.membership?.membershipCreatedByUserId
  if (!creatorId) {
    return null
  }
  // Guard: lastSync can be absent on state rehydrated from a pre-deploy
  // redux-persist snapshot.
  return s.dependents?.lastSync?.profiles?.find((p) => p.id === creatorId) ?? null
}

/**
 * Whether submitting this incident requires the Family plan — i.e. its patient
 * is someone other than the membership creator. Tier-independent; combine with
 * isFamilyLimitedTier (done inside useSubscriptionPrompt) to decide whether to
 * actually block.
 */
export function selectIncidentRequiresFamilyPlan(incident: Pick<IncidentModel, 'patient_name' | 'patient_dob'>) {
  return (s: RootState): boolean =>
    requiresFamilyPlan([incident], selectCreatorProfile(s))
}
